.page {
    min-height: 100vh;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    background: var(--tl-stage);
}

.body {
    max-width: 640px;
    width: 100%;
    margin: 0 auto;
    flex: 1;
    padding: 56px 26px;
}

.body h1 {
    font-weight: 500;
    font-size: 28px;
    letter-spacing: -0.01em;
    color: var(--tl-text);
    margin: 0 0 16px;
}

.body p {
    font-size: 14.5px;
    line-height: 1.7;
    color: var(--tl-muted);
}
